import styled from "styled-components";
import { TextInput } from "../../../../core/components/input/TextInput";
import { getUserAnswerToQuestion } from "../../../../core/store/currentFormSlice";
import { useMainStore } from "../../../../core/store/mainStore";

type Props = {
  questionId: string;
  answerId: string;
};

export const OwnTextAnswer = ({ questionId, answerId }: Props) => {
  const savedText = useMainStore((state) =>
    getUserAnswerToQuestion(state, answerId),
  )?.textValue;

  const setUserAnswerToQuestion = useMainStore(
    (state) => state.setUserAnswerToQuestion,
  );

  const deleteUserAnswerToQuestion = useMainStore(
    (state) => state.deleteUserAnswerToQuestion,
  );

  const handleTextChange = (text: string) => {
    if (text.trim() === "") {
      deleteUserAnswerToQuestion(questionId, answerId);
      return;
    }

    const patientAnswer = {
      id: answerId,
      textValue: text,
    };
    setUserAnswerToQuestion(questionId, patientAnswer, answerId);
  };

  return (
    <FieldsContainer>
      <TextInput
        placeholder="Eigene Antwort"
        onChange={handleTextChange}
        value={savedText || ""}
      />
    </FieldsContainer>
  );
};

const FieldsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
